import React from 'react'
import {Switch as AntSwitch} from 'antd'
import {observer} from 'mobx-react'
import {SwitchProps} from './props'

export const Switch: React.FC<SwitchProps> = observer((props) =>
    <AntSwitch {...props}/>)
